module.exports = __webpack_public_path__ + "static/media/banner_jct.c5f4f4a4.jpg";